export enum MediaType {
  UNKNOWN = 'unknown',
  IMAGE = 'image',
  AUDIO = 'audio',
  VIDEO = 'video',
}
